import ICONS from '@icons';

const PREDEFINED_ICONS = {
  // complete: '...',
  // cancel: '...',
  // close: '...',
  // delete: '...', // delete (e.g. v-chip close)
  // clear: '...',
  success: ICONS['checkboxMarkedCircleOutline'],
  info: ICONS['informationOutline'],
  warning: ICONS['alertCircleOutline'],
  error: ICONS['closeCircleOutline'],
  // prev: '...',
  // next: '...',
  // checkboxOn: '...',
  // checkboxOff: '...',
  // checkboxIndeterminate: '...',
  // delimiter: '...', // for carousel
  // sort: '...',
  // expand: '...',
  // menu: '...',
  // subgroup: '...',
  dropdown: ICONS['chevronDown'],
  // radioOn: '...',
  // radioOff: '...',
  // edit: '...',
  // ratingEmpty: '...',
  // ratingFull: '...',
  // ratingHalf: '...',
  // loading: '...',
  // first: '...',
  // last: '...',
  // unfold: '...',
  // file: '...',
};

export default Object.assign({}, PREDEFINED_ICONS, ICONS);
